import GroupsOverview from './GroupsOverview';

export default GroupsOverview;
